export default __webpack_public_path__ + "static/media/25102003.1566539c.png";